// extracted by mini-css-extract-plugin
module.exports = {"ModalHeader":"FeaturePermission_ModalHeader__2KO0d","ModalBody":"FeaturePermission_ModalBody__1DJaS","ButtonClose":"FeaturePermission_ButtonClose__2Ixze"};